// src/theme/tokens/exam.js
// Faz 1 · Sinav (exam) statu semantic token namespace'i.
// UWorld/AMBOSS modeli: dogru, yanlis, atlanan, isaretli, kismi puan, elenmis cevap.
// Mevcut optionCorrect/Incorrect/Selected token'lari bu yeni katmana ALIAS olur (Faz 4'te).
// Renkler: emerald (correct), rose (incorrect), slate (skipped),
//          amber (review), brand (partial), gray (eliminated).

const examTokens = {
  // ===== CORRECT (dogru cevap) =====
  'exam.correct.bg':       { default: 'emerald.50',  _dark: 'emerald.900' },
  'exam.correct.bgSubtle': { default: 'emerald.25',  _dark: 'emerald.950' },
  'exam.correct.bgSolid':  { default: 'emerald.500', _dark: 'emerald.400' },
  'exam.correct.text':     { default: 'emerald.700', _dark: 'emerald.200' },
  'exam.correct.textOnSolid': { default: 'white',    _dark: 'emerald.950' },
  'exam.correct.border':   { default: 'emerald.300', _dark: 'emerald.700' },
  'exam.correct.icon':     { default: 'emerald.500', _dark: 'emerald.300' },
  'exam.correct.ring':     { default: 'emerald.500_alpha_25', _dark: 'emerald.300_alpha_30' },

  // ===== INCORRECT (yanlis cevap) =====
  'exam.incorrect.bg':       { default: 'rose.50',  _dark: 'rose.900' },
  'exam.incorrect.bgSubtle': { default: 'rose.25',  _dark: 'rose.950' },
  'exam.incorrect.bgSolid':  { default: 'rose.500', _dark: 'rose.400' },
  'exam.incorrect.text':     { default: 'rose.700', _dark: 'rose.200' },
  'exam.incorrect.textOnSolid': { default: 'white', _dark: 'rose.950' },
  'exam.incorrect.border':   { default: 'rose.300', _dark: 'rose.700' },
  'exam.incorrect.icon':     { default: 'rose.500', _dark: 'rose.300' },
  'exam.incorrect.ring':     { default: 'rose.500_alpha_25', _dark: 'rose.300_alpha_30' },

  // ===== SKIPPED (atlanan / cevaplanmamis) =====
  'exam.skipped.bg':       { default: 'slate.50',  _dark: 'slate.800' },
  'exam.skipped.bgSubtle': { default: 'slate.25',  _dark: 'slate.850' },
  'exam.skipped.bgSolid':  { default: 'slate.400', _dark: 'slate.500' },
  'exam.skipped.text':     { default: 'slate.600', _dark: 'slate.300' },
  'exam.skipped.textOnSolid': { default: 'white',  _dark: 'slate.950' },
  'exam.skipped.border':   { default: 'slate.200', _dark: 'slate.700' },
  'exam.skipped.icon':     { default: 'slate.400', _dark: 'slate.500' },

  // ===== REVIEW (gozden gecirilmek uzere isaretli) =====
  'exam.review.bg':       { default: 'amber.50',  _dark: 'amber.900' },
  'exam.review.bgSubtle': { default: 'amber.25',  _dark: 'amber.950' },
  'exam.review.bgSolid':  { default: 'amber.500', _dark: 'amber.400' },
  'exam.review.text':     { default: 'amber.700', _dark: 'amber.200' },
  'exam.review.textOnSolid': { default: 'white',  _dark: 'amber.950' },
  'exam.review.border':   { default: 'amber.300', _dark: 'amber.700' },
  'exam.review.icon':     { default: 'amber.500', _dark: 'amber.300' },
  'exam.review.flag':     { default: 'amber.500', _dark: 'amber.400' },

  // ===== PARTIAL (kismi dogru · meslektaslar kategorisi) =====
  'exam.partial.bg':       { default: 'brand.50',  _dark: 'brand.900' },
  'exam.partial.bgSubtle': { default: 'brand.25',  _dark: 'brand.950' },
  'exam.partial.bgSolid':  { default: 'brand.500', _dark: 'brand.400' },
  'exam.partial.text':     { default: 'brand.700', _dark: 'brand.200' },
  'exam.partial.textOnSolid': { default: 'white',  _dark: 'brand.950' },
  'exam.partial.border':   { default: 'brand.300', _dark: 'brand.700' },
  'exam.partial.icon':     { default: 'brand.500', _dark: 'brand.300' },

  // ===== ELIMINATED (cikartilmis cevap secenegi) =====
  'exam.eliminated.bg':       { default: 'slate.100', _dark: 'slate.800' },
  'exam.eliminated.text':     { default: 'slate.400', _dark: 'slate.500' },
  'exam.eliminated.border':   { default: 'slate.200', _dark: 'slate.700' },
  'exam.eliminated.opacity':  { default: '0.55',      _dark: '0.5' },
  'exam.eliminated.lineThrough': { default: 'slate.400', _dark: 'slate.500' },

  // ===== SELECTED (kullanici sec-aktif, henuz dogrulanmamis) =====
  // Bu namespace mevcut optionSelectedBg ile uyumlu · yellow ailesi korunur.
  'exam.selected.bg':       { default: 'amber.100', _dark: 'amber.800' },
  'exam.selected.bgSolid':  { default: 'amber.300', _dark: 'amber.500' },
  'exam.selected.text':     { default: 'amber.900', _dark: 'amber.50' },
  'exam.selected.border':   { default: 'amber.400', _dark: 'amber.600' },
  'exam.selected.ring':     { default: 'amber.500_alpha_40', _dark: 'amber.300_alpha_30' },

  // ===== HIGHLIGHT (UWorld tarzi onemli kelime/ifade vurgusu) =====
  'exam.highlight.yellow':  { default: 'amber.200',  _dark: 'amber.700' },
  'exam.highlight.green':   { default: 'emerald.200', _dark: 'emerald.700' },
  'exam.highlight.pink':    { default: 'rose.200',    _dark: 'rose.700' },
  'exam.highlight.blue':    { default: 'brand.100',   _dark: 'brand.800' },
  'exam.highlight.text':    { default: 'slate.900',   _dark: 'slate.50' },
};

export default examTokens;
